import { Breathe } from "./Breathe";
import { Orb } from "./Orb";
import { useModus } from "../../../hooks/use-modus";
import { useMicRecorder } from "../../../hooks/use-mic-recorder";
import { RecordingObjectType } from "../../../enums";

export const ModusOrb = ({
  size = 750,
  onProcess,
  orbFontSizeOverride
}: {
  size?: number;
  onProcess: (transcript: string, _: string) => Promise<void>;
  orbFontSizeOverride?: string;
}) => {
  const { modusChatContext, isWaitingForResponse } = useModus();

  const {
    isRecording,
    startRecording,
    stopRecording,
    isInitializing,
    isProcessingAudio
  } = useMicRecorder();

  // Handle orb click to start or stop recording
  const handleOrbClick = () => {
    if (isWaitingForResponse) {
      // Don't do anything if thinking
      return;
    }

    if (isRecording) {
      stopRecording();
    } else {
      startRecording(RecordingObjectType.MODUS_CHAT, onProcess);
    }
  };

  return (
    <div
      style={{ position: "relative", width: `${size}px`, height: `${size}px` }}
    >
      <Orb size={size} thinking={isWaitingForResponse || isProcessingAudio} />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Breathe
          size={size}
          orbFontSizeOverride={orbFontSizeOverride}
          onClick={() => {
            if (modusChatContext && !isInitializing) {
              handleOrbClick();
            }
          }}
        />
      </div>
    </div>
  );
};
